import { render, staticRenderFns } from "./ItemPopup.vue?vue&type=template&id=dfb762ce"
import script from "./ItemPopup.vue?vue&type=script&lang=js"
export * from "./ItemPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports